'use client';
import type { ReactElement } from 'react';
import { useActiveTextCues, useActiveTextTrack } from '@vidstack/react';
import { useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';

import { selectUserDynamicValues } from 'slices/dynamicDataSelectors';
import { UserDynamicValues } from 'types/user';

import { cueAsHTML } from 'utils/video';

interface DynamicTextProps {
  playing: boolean | undefined;
}

export default function DynamicText({
  playing,
}: DynamicTextProps): ReactElement {
  const stateData = useAppSelector((state: RootState) =>
    selectUserDynamicValues(state)
  ) as UserDynamicValues;

  const activeTextTrack = useActiveTextTrack(['metadata']);
  const activeCues = useActiveTextCues(activeTextTrack);

  return (
    <div
      className={`dynamic-text-wrapper ${playing ? 'playing' : 'not-playing'}`}
      data-testid="dynamic-text-wrapper"
    >
      {activeCues.map((cue) => {
        return cueAsHTML(cue as VTTCue, stateData);
      })}
    </div>
  );
}
